import { Profile } from "../../../profiles/models/profile"

export class SupplierOtherCreditorProfile {
  ref: number;
  name: string;
  type: string;
  profile: Profile;
}
